export default __webpack_public_path__ + "static/media/Ballroll_00261.de27e815.png";